import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const FloatingSpeedTest = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.7, duration: 0.6 }}
      className="fixed left-0 top-[44%] z-50 hidden lg:block"
    >
      <Link
        to="/speed-test"
        className="group flex items-center gap-3 bg-primary/95 backdrop-blur-md border border-l-0 border-secondary/25 hover:border-secondary py-3.5 px-5 rounded-r-2xl shadow-[0_15px_35px_rgba(0,0,0,0.5)] transition-all duration-300 relative overflow-hidden"
        aria-label="أداة فحص سرعة المواقع المجانية"
      >
        {/* Glow effect on hover */}
        <div className="absolute inset-0 bg-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

        {/* Pulsing indicator dot */}
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
        </span>

        <span className="text-xs font-bold text-light group-hover:text-secondary transition-colors duration-300 select-none whitespace-nowrap">
          فحص سرعة موقعك
        </span>

        <i className="fas fa-bolt text-secondary text-base group-hover:scale-110 transition-transform duration-300" />
      </Link>
    </motion.div>
  );
};

export default FloatingSpeedTest;
